import { createJsonAdapter } from './jsonAdapter';
import { toMultipart } from '~/utils/helper/setupForm';

export type MemoryType = 'PHOTO' | 'AUDIO';

export interface IMemoryRow {
  id: string;
  name?: string | null;
  url?: string | null;
  thumbnailUrl?: string | null;
  mimetype?: string | null;
  size?: number | null;
  createdAt?: string | null;
  descriptions?: string | null;
}

// Photos take images + video, Songs take audio + video (same as the app's pickers).
export const MEMORY_ACCEPT: Record<MemoryType, string> = {
  PHOTO: 'image/*,video/*',
  AUDIO: 'audio/*,video/*',
};

// A memory is a file of businessType PHOTO / AUDIO; the upload endpoint differs from the one for edit/delete.
export const createMemoryAdapter = (type: MemoryType) =>
  createJsonAdapter<IMemoryRow>({
    url: 'files',
    createUrl: 'files/upload-files',
    listParams: { businessTypes: type },
    rowToForm: (row) => ({
      description: row.descriptions ?? '',
      // a string is the saved file's url; only a newly picked File is uploaded
      file: row.url ?? '',
      thumbnail: row.thumbnailUrl ?? '',
      fileName: row.name ?? '',
      mimetype: row.mimetype ?? '',
      size: row.size ?? '',
      createdAt: row.createdAt ?? '',
    }),
    toBody: (form, isCreate) =>
      toMultipart({
        businessType: type,
        method: 'FILE',
        descriptions: String(form.description ?? '').trim(),
        // the uploaded file itself can't be swapped on edit, only its description
        ...(isCreate && form.file instanceof File ? { files: form.file } : {}),
      }),
  });
